//解决页面布局 table高度适配问题，不是每个页面都实用，如果需要使用这个插件
//就需要在需要根据高度改变的table或者容器  利用 全局变量 tableHeigth 设定对应容器高度
//例如：<el-table :height="tableHeigth">
var lpyMixin = {
    data: function() {
        return {
            tableHeigth: 0,
            tableHeightSubtract: 360, //table高度计算减去的值
            projectPathName:"/hxkj_management_server_api"
        }
    },
    created() {
        this.resetSize();
    },
    beforeMount() {
        window.addEventListener("resize", this.resetSize);

    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resetSize);
    },
    methods: {
        resetSize() {
            let h = document.documentElement.clientHeight || document.body.clientHeight;
            this.tableHeigth = h - this.tableHeightSubtract;
            // console.log(h);
        }

    },
    watch: {
        tableHeightSubtract: function(newQuestion, oldQuestion) {
            this.resetSize()
            // console.log(this.tableHeightSubtract)
            // console.log(this.tableHeigth)
        }
    }
}

export default {
    install(Vue) {
        Vue.mixin(lpyMixin)
    }
}


// WEBPACK FOOTER //
// ./src/mixin/lpyMixin.js